function Logo() {
  return (
    <div className="Logo">
      <img class="logo" src="/img/hickmanlogo.png" alt="Chris Hickman Logo" />
    </div>
  );
}

export default Logo;
